/**************************************************
 * Nombre:       Dialogo_Wass
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {NEGRITA} from "../../Constantes";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import Formulario_Wass from "../Formularios/Formulario_Wass";
import {WhatsApp} from '@mui/icons-material'

const Dialogo_Wass = ({datos}) => {
    const {props} = useFormulario({valoresDefecto: datos})


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 2}}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <Typography sx={{fontFamily: NEGRITA, fontSize: 32, lineHeight: 1.1}}>Queremos que tu atencion sea
                    perzonalizada</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 1}}>
                <Typography sx={{fontSize: 16}}>
                    Permitenos saber quien eres y asi atenderte de manera personal. Siempre el asesor estar enterado de tus intereses y tu
                    proceso
                </Typography>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                <Formulario_Wass props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 3}}>
                <Button
                    startIcon={<WhatsApp/>}
                    sx={{color: '#fff'}}
                >
                    Seguir conversacion
                </Button>
            </Grid>

        </Grid>
    )

}
export default Dialogo_Wass